export default __webpack_public_path__ + "static/media/eur.762d06e3.svg";